export default import.meta.ROLLUP_FILE_URL_LphhLScmzwPqWwTyAbd7ig;